import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SimpleBarChart.module.css';

const SimpleBarChart = ({ data, title, maxValue }) => {
  const navigate = useNavigate();
  if (!data || data.length === 0) {
    return (
      <div className={styles.chartContainer}>
        <h3>{title}</h3>
        <p className={styles.noData}>No data available</p>
      </div>
    );
  }

  const maxVal = maxValue || Math.max(...data.map(d => d.value));

  return (
    <div className={styles.chartContainer}>
      <h3>{title}</h3>
      <div className={styles.chart}>
        {data.map((item, index) => (
          <div 
            key={index} 
            className={styles.barContainer}
            onClick={() => item.canvassId && navigate(`/canvass/${item.canvassId}`)}
            style={{ cursor: item.canvassId ? 'pointer' : 'default' }}
          >
            <div className={styles.barWrapper}>
              <div 
                className={styles.bar}
                style={{ 
                  height: `${(item.value / maxVal) * 100}%`,
                  backgroundColor: item.color || '#3b82f6'
                }}
              />
            </div>
            <div className={styles.label}>
              <div className={styles.name}>{item.name}</div>
              <div className={styles.value}>{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimpleBarChart;
